import React from 'react';
import { RootStateOrAny, useSelector } from 'react-redux'
import IndexTable from './IndexTable';

const NeoplasmsTable = () => {
    const neoplasmsTable = useSelector((state: RootStateOrAny) => state.neoplasmsTable)
    const searchTerm = useSelector((state: RootStateOrAny) => state.searchTerm)

    return (<IndexTable tableData={neoplasmsTable} searchTerm={searchTerm} id="neoplasms-table" />)
}

export default NeoplasmsTable